import AntdIcon from "@ant-design/icons";
import { useIconStyles } from "./theme/Icon.styles";
import type { GetProps } from "antd";

export type IconProps = Partial<GetProps<typeof AntdIcon>>;

export const Icon = ({
  className,
  size,
  color,
  style,
  ...props
}: IconProps) => {
  const { styles, cx } = useIconStyles();

  const getStyle = () => {
    let result = {};

    if (size) {
      result = {
        ...result,
        fontSize: size,
      };
    }

    if (color) {
      result = {
        ...result,
        color: color,
      };
    }

    return { ...result, ...style };
  };

  return (
    <AntdIcon
      className={cx(className, styles.icon)}
      style={getStyle()}
      {...props}
    />
  );
};
